/**
 * Skeleton placeholder for the header CTA button while session loads.
 * Matches the dimensions of the Button.a used in HeaderCta.
 */
export default function HeaderCtaFallback() {
  return (
    <div
      className="h-[var(--button-primary-block-height)] w-24 animate-pulse rounded-[var(--button-primary-block-border-radius)] bg-white/10 max-md:size-8 max-md:w-auto max-md:rounded-full"
      aria-hidden
    />
  )
}
